'use client';

// Transparent labeling for the official AI account: every place a username
// shows in the forum, the bot gets a visible "AI" chip. Non-negotiable —
// readers must always know when content is machine-generated.

import { useLang } from '@/lib/i18n/LanguageContext';

export const AI_USERNAMES = new Set(['ai_analiticar']);

export function isAiUser(username?: string | null): boolean {
  return !!username && AI_USERNAMES.has(username);
}

export function AiBadge({ username }: { username?: string | null }) {
  const { t } = useLang();
  if (!isAiUser(username)) return null;
  return (
    <span
      className="text-[9px] font-bold px-1.5 py-px rounded"
      style={{ background: 'var(--info-muted)', color: 'var(--info)', letterSpacing: '0.05em' }}
      title={t('Official AI account — posts are generated by artificial intelligence. Not financial advice.')}
    >
      AI
    </span>
  );
}
